import {Button, DatePicker, Form, Input, Layout, Radio, TableColumnsType, Tag} from "antd";
import {PlusCircleOutlined} from "@ant-design/icons/lib";
import React, {useMemo, useState} from "react";
import CommonTableComponent from "../common-table-component";
import resources from "../../../resources";
import server from "../../../server";
import Locale from "../../../core/locale/locale";

const columns: TableColumnsType = [
    {
        title: "Display Name",
        dataIndex: 'displayName',
        align: "left",
    },
    {
        title: 'Start Date',
        dataIndex: 'startDate',
        align: "left",
        render: (value: any) => value || "-",
    },
    {
        title: 'End Date',
        dataIndex: 'endDate',
        align: "left",
        render: (value: any) => value || "-",
    },
    {
        title: 'Status',
        dataIndex: 'active',
        align: "left",
        render: (active: boolean) => (
            <Tag className={`status-pill ${active ? "active" : "inactive"}`}>
                {active ? "Active" : "Inactive"}
            </Tag>
        ),
    },
]

const isActive = [
    {label: 'Yes', value: true},
    {label: 'No', value: false},
];

const LeavePeriod = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const tempResources = resources.commonButtonText;
    const leavePeriodColumn = columns;

    const fetchAllLeavePeriod = async () => {
        try {
            await server.leave.period.list();
        } catch (e) {
            console.log(Error);
        }
    }

    const propsData = useMemo(
        () => ({
            title: "Leave Period",
            create: server.leave.period.create,
            getAll: server.leave.period.list,
            update: server.leave.period.updateStatus,
            updateLeavePeriodById: server.leave.period.update,
            isModalOpen: isModalOpen,
            setIsModalOpen: setIsModalOpen,
            columns: leavePeriodColumn,
            deleteById: server.leave.period.delete,
            formFields: [
                <Form.Item
                    label="Display Name"
                    name="displayName"
                    rules={[{required: true, message: 'Please enter display name!!'}]}
                >
                    <Input placeholder={"Enter display name"}/>
                </Form.Item>,
                <Form.Item
                    label="Start Date"
                    name={"startDate"}
                    rules={[{required: true, message: 'Please input Start Date!'}]}
                >
                    <DatePicker name={"startDate"} format={Locale.displayDate} style={{width: "100%"}}/>
                </Form.Item>,
                <Form.Item
                    label="End Date"
                    name="endDate"
                    rules={[{required: true, message: 'Please input end Date!!'}]}>
                    <DatePicker name={"endDate"} format={Locale.displayDate} style={{width: "100%"}}/>
                </Form.Item>,

                <Form.Item
                    label="Is Active ?"
                    name={"active"}
                    className="formInputFields"
                    rules={[{required: true, message: 'Please choose Yes/No'}]}
                >
                    <Radio.Group
                        size='large'
                        className={'leave-period-radio-button'}
                        name="radiogroup"
                        options={isActive}
                    />
                </Form.Item>
            ],
            formFieldsType: [
                {name: "displayName", type: "string"},
                {name: "startDate", type: "date"},
                {name: "endDate", type: "date"},
                {name: "active", type: "boolean"},
            ],
            tableFieldsType: [
                {name: "displayName", type: "string"},
                {name: "startDate", type: "date"},
                {name: "endDate", type: "date"},
                {name: "active", type: "boolean"},
            ],
            showStatus: true,
            updateRecord: true
        }),
        [isModalOpen, setIsModalOpen, leavePeriodColumn, fetchAllLeavePeriod]
    );

    return (
        <div className="settings-section">
            <div className={'settings-section__heading'}>
                <h4>Leave Period</h4>
            <Button type="primary"
                    icon={<PlusCircleOutlined/>}
                    onClick={() => setIsModalOpen(true)}
                    className="settings-section__action-button">
                {tempResources.addButton}
            </Button>
            </div>
            <Layout className="settings-section__table-layout">
                <CommonTableComponent propsData={propsData}/>
            </Layout>
        </div>
    )
}

export default LeavePeriod;
